import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { CriminalInvestigations } from './pages/CriminalInvestigations';
import { CorporateInvestigations } from './pages/CorporateInvestigations';
import { DomesticInvestigations } from './pages/DomesticInvestigations';
import { ChildCustodyInvestigations } from './pages/ChildCustodyInvestigations';
import { MissingPersonsInvestigations } from './pages/MissingPersonsInvestigations';
import { ConstructionInvestigations } from './pages/ConstructionInvestigations';
export function AppRouter() {
  return <Router data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/criminal-investigations" element={<CriminalInvestigations data-id="element-15" />} data-id="element-14" />
        <Route path="/corporate-investigations" element={<CorporateInvestigations data-id="element-17" />} data-id="element-16" />
        <Route path="/domestic-investigations" element={<DomesticInvestigations data-id="element-19" />} data-id="element-18" />
        <Route path="/child-custody-investigations" element={<ChildCustodyInvestigations data-id="element-21" />} data-id="element-20" />
        <Route path="/missing-persons-investigations" element={<MissingPersonsInvestigations data-id="element-23" />} data-id="element-22" />
        <Route path="/construction-investigations" element={<ConstructionInvestigations data-id="element-25" />} data-id="element-24" />
      </Routes>
    </Router>;
}